<template>
<v-container fluid>
  <v-row>
    <v-col cols="12">
      <v-tabs v-model="tab" grow>
        <v-tab key="0">Lista</v-tab>
        <v-tab key="1" v-show="$can('do','POKO_Vouchery_Dodawanie')">Dodawanie</v-tab>
        <v-tab key="2">Sprzedaż</v-tab>

      </v-tabs>
      <v-tabs-items v-model="tab">
      <v-tab-item key="0" >
        <ListaVoucherow v-if="tab == 0" :szukanynumer="szukanynumer"></ListaVoucherow>
      </v-tab-item>
        <v-tab-item key="1">
              <DodawanieVouchera if="tab == 1 && $can('do','POKO_Vouchery_Dodawanie')" @added="addedVoucher"></DodawanieVouchera>
        </v-tab-item>
        <v-tab-item key="2" >
              <SprzedazVoucherow v-if="tab == 2"></SprzedazVoucherow>
        </v-tab-item>

      </v-tabs-items>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import DodawanieVouchera from "@/components/vouchery/DodawanieVouchera";
import ListaVoucherow from "@/components/vouchery/ListaVoucherow";
import SprzedazVoucherow from "@/components/vouchery/SprzedazVoucherow";
export default {
  name: "Vouchery",
  components: {SprzedazVoucherow, ListaVoucherow, DodawanieVouchera},
  data() {
    return {
      tab: null,
      szukanynumer: ''
    }
  },
  methods: {
    addedVoucher(voucher) {
      this.szukanynumer = voucher.numer
      this.tab = 0
    }
  },
  watch: {
    tab: function(val) {
      if(val != 0)
      {
        this.szukanynumer = ''
      }
    }
  }
}
</script>

<style scoped>

</style>